function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import $ from 'jquery';
import Backbone from '@polleverywhere/backbone';
/**
 * Participant / presenter relationship model used to determine if a
 * relationship already exists, udpate or a create a new one.
 */

var PresenterRelationship = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(PresenterRelationship, _Backbone$Model);

  function PresenterRelationship() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = PresenterRelationship.prototype;

  _proto.fetch = function fetch(options) {
    if (options == null) {
      options = {};
    }

    options.url = "/api/participants/" + this.get('participant_id') + "/presenters/" + this.get('presenter_id') + "/relationship";
    return _Backbone$Model.prototype.fetch.call(this, options);
  };

  _proto.hasNullScreenname = function hasNullScreenname() {
    // NOTE: Check specifically for null, not undefined or ""; but null!
    return this.isNew() || this.get('screen_name') === null;
  };

  _proto.save = function save(attributes, options) {
    var _this = this;

    return $.Deferred(function (dfd) {
      _Backbone$Model.prototype.save.call(_this, attributes, options).fail(function (xhr) {
        if (xhr.status === 409) {
          var error = xhr.responseJSON.error;

          if (error.detail.id) {
            _this.set({
              id: error.detail.id
            });

            return _this.save(attributes, options).fail(function (xhr) {
              return dfd.reject(xhr, 'Failed after retrying to save relationship');
            }).then(dfd.resolve);
          } else {
            return dfd.reject(xhr, 'Conflict while saving relationship');
          }
        } else {
          return dfd.reject(xhr, 'Failed to update/create relationship');
        }
      }).then(dfd.resolve);
    });
  };

  _createClass(PresenterRelationship, [{
    key: "urlRoot",
    get: function get() {
      return '/api/participant_presenter_relationships';
    }
  }]);

  return PresenterRelationship;
}(Backbone.Model);

export { PresenterRelationship as default };